var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"loading_pool"}),_c('div',{staticClass:"loading_box"},[_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../../assets/images/loading.png"),"alt":"铜仁学院省级专业技术人员继续教育培训平台"}}),_c('p',{staticClass:"loading_text"},[_vm._v("加载中...")])])])])
}]

export { render, staticRenderFns }